<div id="loading-container" class="max-z-index" *ngIf="show">
  <div id="loading-bar-spinner">
    <div class="spinner-icon"></div>
  </div>
</div>
<div id="loading-container-header" *ngIf="showLoader">
  <div id="loading-bar-spinner-header">
    <div class="spinner-icon"></div>
  </div>
</div>
